import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import ltcRatings from "../../../../src/data/articles/cube-prospective-tales-of-middle-earth-commander/ltc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  ltcRatings,
  ProspectiveIntro,
  React
};